import React, { useState } from "react";

const TeamEditModal = ({
  team,
  divisionKey,
  availablePlayers,
  onCancel,
  onSave,
  onDelete,
  isSingles,
  isAdding = false,
}) => {
  const [selectedPlayers, setSelectedPlayers] = useState(
    team?.players || []
  );

  const handlePlayerChange = (index, playerId) => {
    const player = availablePlayers.find((p) => p.userId === playerId);
    if (!player) return;

    const newPlayers = [...selectedPlayers];
    // Ensure array is long enough
    while (newPlayers.length <= index) {
      newPlayers.push(null);
    }
    newPlayers[index] = player;
    setSelectedPlayers(newPlayers);
  };

  const handleSave = () => {
    // Filter out any null/undefined values
    const validPlayers = selectedPlayers.filter(p => p);

    if (isSingles && validPlayers.length !== 1) {
      alert("Veuillez sélectionner 1 joueur");
      return;
    }
    if (!isSingles && validPlayers.length !== 2) {
      alert("Veuillez sélectionner 2 joueurs");
      return;
    }

    const updatedTeam = {
      ...team,
      players: validPlayers,
      totalRanking: validPlayers.reduce(
        (sum, p) => sum + (p.ranking || 0),
        0
      ),
    };

    onSave(divisionKey, updatedTeam);
  };

  const getAvailablePlayersForSlot = (slotIndex) => {
    return availablePlayers
      .filter((player) => {
        // Allow current player
        if (selectedPlayers[slotIndex]?.userId === player.userId) {
          return true;
        }
        // Don't show players already selected in other slots
        return !selectedPlayers.some((p) => p?.userId === player.userId);
      })
      .sort((a, b) => a.name.localeCompare(b.name));
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-slate-800 border border-slate-700 text-slate-50 rounded-lg shadow-xl p-6 w-full max-w-md mx-4">
        <h2 className="text-2xl font-bold mb-6 text-center">
          {isAdding ? "Ajouter une nouvelle équipe" : `Modifier l'équipe ${team?.teamNumber}`}
        </h2>

        <div className="flex flex-col gap-4 mb-6">
          {/* Player 1 */}
          <div className="flex flex-col gap-2">
            <label className="text-sm font-semibold">Joueur 1</label>
            <select
              className="bg-slate-800 text-slate-50 px-3 py-2 rounded border border-slate-700 focus:border-blue-400 focus:outline-none"
              value={selectedPlayers[0]?.userId || ""}
              onChange={(e) => handlePlayerChange(0, e.target.value)}
            >
              <option value="">Sélectionner un joueur</option>
              {getAvailablePlayersForSlot(0).map((player) => (
                <option key={player.userId} value={player.userId}>
                  {player.name} (Elo: {player.ranking || 0})
                </option>
              ))}
            </select>
          </div>

          {/* Player 2 (only for doubles) */}
          {!isSingles && (
            <div className="flex flex-col gap-2">
              <label className="text-sm font-semibold">Joueur 2</label>
              <select
                className="bg-slate-800 text-slate-50 px-3 py-2 rounded border border-slate-700 focus:border-blue-400 focus:outline-none"
                value={selectedPlayers[1]?.userId || ""}
                onChange={(e) => handlePlayerChange(1, e.target.value)}
              >
                <option value="">Sélectionner un joueur</option>
                {getAvailablePlayersForSlot(1).map((player) => (
                  <option key={player.userId} value={player.userId}>
                    {player.name} (Elo: {player.ranking || 0})
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* Total Ranking Display */}
          <div className="bg-slate-800 rounded p-3 text-center">
            <span className="text-sm text-slate-200">Elo total:</span>
            <span className="ml-2 text-lg font-bold text-emerald-400">
              {selectedPlayers.filter(p => p).reduce((sum, p) => sum + (p?.ranking || 0), 0)}
            </span>
          </div>
        </div>

        <div className="flex justify-between gap-4">
          {!isAdding && onDelete && (
            <button
              className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded"
              onClick={() => onDelete(divisionKey, team.teamNumber)}
            >
              Supprimer
            </button>
          )}
          <div className={`flex gap-4 ${isAdding || !onDelete ? 'ml-auto' : ''}`}>
            <button
              className="px-4 py-2 bg-slate-700 hover:bg-slate-800/50 text-slate-50 rounded"
              onClick={onCancel}
            >
              Annuler
            </button>
            <button
              className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded"
              onClick={handleSave}
            >
              Enregistrer
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamEditModal;
